const validarrp = (dataChange, totRecibido, totRecib, saldoPendiente)=>{
  let validado = []
  if (dataChange.efectivo){
    if (dataChange.efectivo<0 || dataChange.efectivo!==parseInt(dataChange.efectivo, 10)){
      validado.push({path: 'Valor pagado', message: `El valor en efectivo (${dataChange.efectivo}) no es válido`});
    }
  }
  
  if(totRecibido<=0){
    validado.push({path: 'Valor pagado', message: `El valor del pago (${totRecibido}) debe ser mayor que cero`});
  }
//  console.log(totRecibido, totRecib, saldoPendiente)
  if(totRecibido<=saldoPendiente&&totRecib!==totRecibido){
    validado.push({path: 'Valor pagado', message: `El valor del pago (${totRecibido}) no coincide con el valor del detalle por pagar (${totRecib})`});
  }
  if(totRecibido>saldoPendiente&&totRecib!==saldoPendiente&&saldoPendiente>0){
    validado.push({path: 'Valor pagado', message: `El valor del pago (${totRecibido}= es mayor al valor relacionado en el detalle por pagar (${totRecib}), debe quedar pago todo el detalle relacionado como pendiente por pagar`});
  }
// console.log(validado)
  return(validado)
}

export default validarrp